import { projectRejectedKey } from 'root/src/shared/constants/keys'

import { REJECT_ACTIVE_PROJECT } from 'root/src/shared/descriptions/recordClickActions/recordClickActionIds'
import { AUDIT_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls'

export default {
	[REJECT_ACTIVE_PROJECT]: {
		endpointId: AUDIT_PROJECT,
		payloadMap: [
			['projectUrl', { $sub: ['recordId'] }],
			['audit', projectRejectedKey],
		],
		label: 'Reject  (admin)',
		onSuccessRecordUpdates: [
			{
				modification: 'set',
				path: ['project', ':recordStoreKey', 'status'],
				value: projectRejectedKey,
			},
		],
		onSuccessRedirect: { routeId: routeUrls.drops() },
	},
}
